/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../public/upgrade/root.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/render/api';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/metadata/view';
import * as import5 from '../../../public/upgrade/core/console-logger.service';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/constants';
import * as import8 from '@angular/core/src/linker/component_factory';
import * as import9 from '../../../public/upgrade/core/session.service';
import * as import10 from '@ngx-translate/core/src/translate.service';
import * as import11 from '../../../public/upgrade/root/background-color/background-color.service';
import * as import12 from '../../../public/upgrade/core/version-check.service';
import * as import13 from '@angular/router/src/router_state';
import * as import14 from '../../../public/upgrade/core/logger.service';
import * as import15 from 'ngx-cookie/src/cookie.service';
import * as import16 from '../../../public/upgrade/root/sara-header/sara-header.component';
import * as import17 from './root/sara-header/sara-header.component.ngfactory';
import * as import18 from '../../node_modules/@angular/common/src/directives/ng_class.ngfactory';
import * as import19 from '@angular/core/src/linker/view_container';
import * as import20 from '../../node_modules/@angular/router/src/directives/router_outlet.ngfactory';
import * as import21 from '../../../public/upgrade/root/loading/loading-wheel.component';
import * as import22 from './root/loading/loading-wheel.component.ngfactory';
import * as import23 from '../../../public/upgrade/root/information-modal/information-modal.component';
import * as import24 from './root/information-modal/information-modal.component.ngfactory';
import * as import25 from '../../../public/upgrade/root/modal/modal.component';
import * as import26 from './root/modal/modal.component.ngfactory';
import * as import27 from '../../../public/upgrade/root/toast/toast.component';
import * as import28 from './root/toast/toast.component.ngfactory';
import * as import29 from '@angular/core/src/change_detection/change_detection_util';
import * as import30 from '@angular/router/src/router';
import * as import31 from '../../../public/upgrade/root/sara-header/navigation.service';
import * as import32 from '@angular/common/src/location/location';
import * as import33 from '@angular/core/src/zone/ng_zone';
import * as import34 from '../../../public/upgrade/root/ga/ga.service';
import * as import35 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import36 from '@angular/core/src/change_detection/differs/keyvalue_differs';
import * as import37 from '@angular/core/src/linker/element_ref';
import * as import38 from '@angular/router/src/router_outlet_map';
import * as import39 from '@angular/core/src/linker/component_factory_resolver';
import * as import40 from '../../../public/upgrade/root/loading/loading-wheel.service';
import * as import41 from '../../../public/upgrade/root/information-modal/information-modal.service';
import * as import42 from '../../../public/upgrade/root/modal/modal.service';
import * as import43 from '../../../public/upgrade/root/toast/notification.service';
import * as import44 from '@angular/router/src/directives/router_outlet';
import * as import45 from '@angular/common/src/directives/ng_class';
export class Wrapper_RootCmp {
  /*private*/ _eventHandler:Function;
  context:import0.RootCmp;
  /*private*/ _changed:boolean;
  constructor(p0:any,p1:any,p2:any,p3:any,p4:any,p5:any,p6:any) {
    this._changed = false;
    this.context = new import0.RootCmp(p0,p1,p2,p3,p4,p5,p6);
  }
  ngOnDetach(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
  }
  ngDoCheck(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  checkHost(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import1.AppView<any>,_eventHandler:any):void {
    this._eventHandler = _eventHandler;
  }
}
var renderType_RootCmp_Host:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,([] as any[]),{});
class View_RootCmp_Host0 extends import1.AppView<any> {
  _el_0:any;
  compView_0:import1.AppView<import0.RootCmp>;
  _RootCmp_0_3:Wrapper_RootCmp;
  __ConsoleLoggerService_0_4:import5.ConsoleLoggerService;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_RootCmp_Host0,renderType_RootCmp_Host,import6.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
  }
  get _ConsoleLoggerService_0_4():import5.ConsoleLoggerService {
    if ((this.__ConsoleLoggerService_0_4 == null)) { (this.__ConsoleLoggerService_0_4 = new import5.ConsoleLoggerService()); }
    return this.__ConsoleLoggerService_0_4;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'root-cmp',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_RootCmp0(this.viewUtils,this,0,this._el_0);
    this._RootCmp_0_3 = new Wrapper_RootCmp(this.injectorGet(import9.SessionService,this.parentIndex),this.injectorGet(import10.TranslateService,this.parentIndex),this.injectorGet(import11.BackgroundColorService,this.parentIndex),this.injectorGet(import12.VersionCheckService,this.parentIndex),this.injectorGet(import13.ActivatedRoute,this.parentIndex),this.injectorGet(import14.LoggerService,this.parentIndex),this.injectorGet(import15.CookieService,this.parentIndex));
    this.compView_0.create(this._RootCmp_0_3.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import8.ComponentRef_<any>(0,this,this._el_0,this._RootCmp_0_3.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.RootCmp) && (0 === requestNodeIndex))) { return this._RootCmp_0_3.context; }
    if (((token === import5.ConsoleLoggerService) && (0 === requestNodeIndex))) { return this._ConsoleLoggerService_0_4; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._RootCmp_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const RootCmpNgFactory:import8.ComponentFactory<import0.RootCmp> = new import8.ComponentFactory<import0.RootCmp>('root-cmp',View_RootCmp_Host0,import0.RootCmp);
const styles_RootCmp:any[] = ([] as any[]);
var renderType_RootCmp:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,styles_RootCmp,{});
export class View_RootCmp0 extends import1.AppView<import0.RootCmp> {
  _el_0:any;
  compView_0:import1.AppView<import16.HeaderComponent>;
  _HeaderComponent_0_3:import17.Wrapper_HeaderComponent;
  _text_1:any;
  _el_2:any;
  _NgClass_2_3:import18.Wrapper_NgClass;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _NgClass_6_3:import18.Wrapper_NgClass;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _text_10:any;
  _el_11:any;
  _text_12:any;
  _el_13:any;
  /*private*/ _vc_13:import19.ViewContainer;
  _RouterOutlet_13_5:import20.Wrapper_RouterOutlet;
  _text_14:any;
  _text_15:any;
  _text_16:any;
  _el_17:any;
  compView_17:import1.AppView<import21.LoadingWheelComponent>;
  _LoadingWheelComponent_17_3:import22.Wrapper_LoadingWheelComponent;
  _text_18:any;
  _el_19:any;
  _text_20:any;
  _text_21:any;
  _el_22:any;
  compView_22:import1.AppView<import23.InformationModalComponent>;
  _InformationModalComponent_22_3:import24.Wrapper_InformationModalComponent;
  _text_23:any;
  _text_24:any;
  _el_25:any;
  compView_25:import1.AppView<import25.ModalComponent>;
  _ModalComponent_25_3:import26.Wrapper_ModalComponent;
  _text_26:any;
  _text_27:any;
  _el_28:any;
  compView_28:import1.AppView<import27.ToastComponent>;
  _ToastComponent_28_3:import28.Wrapper_ToastComponent;
  _text_29:any;
  _text_30:any;
  _text_31:any;
  /*private*/ _expr_46:any;
  /*private*/ _expr_47:any;
  _map_48:any;
  _map_49:any;
  /*private*/ _expr_50:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_RootCmp0,renderType_RootCmp,import6.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_46 = import29.UNINITIALIZED;
    this._expr_47 = import29.UNINITIALIZED;
    this._map_48 = import3.pureProxy2((p0:any,p1:any):{[key: string]:any} => {
      return {
        'login-body': p0,
        'whitesmoke-body': p1
      }
      ;
    });
    this._map_49 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {'whitesmoke-back': p0};
    });
    this._expr_50 = import29.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'sara-header',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_0 = new import17.View_HeaderComponent0(this.viewUtils,this,0,this._el_0);
    this._HeaderComponent_0_3 = new import17.Wrapper_HeaderComponent(this.parentView.injectorGet(import9.SessionService,this.parentIndex),this.parentView.injectorGet(import30.Router,this.parentIndex),this.parentView.injectorGet(import31.NavigationService,this.parentIndex),this.parentView.injectorGet(import32.Location,this.parentIndex),this.parentView.injectorGet(import33.NgZone,this.parentIndex),this.parentView.injectorGet(import15.CookieService,this.parentIndex),this.parentView.injectorGet(import34.GAService,this.parentIndex),this.parentView.injectorGet(import10.TranslateService,this.parentIndex));
    this.compView_0.create(this._HeaderComponent_0_3.context);
    this._text_1 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,parentRenderNode,'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._NgClass_2_3 = new import18.Wrapper_NgClass(this.parentView.injectorGet(import35.IterableDiffers,this.parentIndex),this.parentView.injectorGet(import36.KeyValueDiffers,this.parentIndex),new import37.ElementRef(this._el_2),this.renderer);
    this._text_3 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray4(4,'class','submenu-bar','ng-show','showSubMenu'),(null as any));
    this._text_5 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','eva-3-container'),(null as any));
    this._NgClass_6_3 = new import18.Wrapper_NgClass(this.parentView.injectorGet(import35.IterableDiffers,this.parentIndex),this.parentView.injectorGet(import36.KeyValueDiffers,this.parentIndex),new import37.ElementRef(this._el_6),this.renderer);
    this._text_7 = this.renderer.createText(this._el_6,'\n        ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','nopadding'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'\n            ',(null as any));
    this._text_10 = this.renderer.createText(this._el_8,'\n            ',(null as any));
    this._el_11 = import3.createRenderElement(this.renderer,this._el_8,'div',new import3.InlineArray8(6,'autoscroll','true','class','sara-main-view-content','ng-view',''),(null as any));
    this._text_12 = this.renderer.createText(this._el_8,'\n            ',(null as any));
    this._el_13 = import3.createRenderElement(this.renderer,this._el_8,'router-outlet',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._vc_13 = new import19.ViewContainer(13,8,this,this._el_13);
    this._RouterOutlet_13_5 = new import20.Wrapper_RouterOutlet(this.parentView.injectorGet(import38.RouterOutletMap,this.parentIndex),this._vc_13.vcRef,this.parentView.injectorGet(import39.ComponentFactoryResolver,this.parentIndex),(null as any));
    this._text_14 = this.renderer.createText(this._el_8,'\n        ',(null as any));
    this._text_15 = this.renderer.createText(this._el_6,'\n        ',(null as any));
    this._text_16 = this.renderer.createText(this._el_6,'\n        ',(null as any));
    this._el_17 = import3.createRenderElement(this.renderer,this._el_6,'loading-wheel',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_17 = new import22.View_LoadingWheelComponent0(this.viewUtils,this,17,this._el_17);
    this._LoadingWheelComponent_17_3 = new import22.Wrapper_LoadingWheelComponent(this.parentView.injectorGet(import40.LoadingWheelService,this.parentIndex),this.compView_17.ref);
    this.compView_17.create(this._LoadingWheelComponent_17_3.context);
    this._text_18 = this.renderer.createText(this._el_6,'\n\n        ',(null as any));
    this._el_19 = import3.createRenderElement(this.renderer,this._el_6,'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_20 = this.renderer.createText(this._el_19,'\n            ',(null as any));
    this._text_21 = this.renderer.createText(this._el_19,'\n            ',(null as any));
    this._el_22 = import3.createRenderElement(this.renderer,this._el_19,'information-modal',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_22 = new import24.View_InformationModalComponent0(this.viewUtils,this,22,this._el_22);
    this._InformationModalComponent_22_3 = new import24.Wrapper_InformationModalComponent(this.parentView.injectorGet(import41.InformationModalService,this.parentIndex));
    this.compView_22.create(this._InformationModalComponent_22_3.context);
    this._text_23 = this.renderer.createText(this._el_19,'\n            ',(null as any));
    this._text_24 = this.renderer.createText(this._el_19,'\n            ',(null as any));
    this._el_25 = import3.createRenderElement(this.renderer,this._el_19,'modal',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_25 = new import26.View_ModalComponent0(this.viewUtils,this,25,this._el_25);
    this._ModalComponent_25_3 = new import26.Wrapper_ModalComponent(this.parentView.injectorGet(import42.ModalService,this.parentIndex));
    this.compView_25.create(this._ModalComponent_25_3.context);
    this._text_26 = this.renderer.createText(this._el_19,'\n            ',(null as any));
    this._text_27 = this.renderer.createText(this._el_19,'\n            ',(null as any));
    this._el_28 = import3.createRenderElement(this.renderer,this._el_19,'toast',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_28 = new import28.View_ToastComponent0(this.viewUtils,this,28,this._el_28);
    this._ToastComponent_28_3 = new import28.Wrapper_ToastComponent(this.parentView.injectorGet(import43.NotificationService,this.parentIndex));
    this.compView_28.create(this._ToastComponent_28_3.context);
    this._text_29 = this.renderer.createText(this._el_19,'\n        ',(null as any));
    this._text_30 = this.renderer.createText(this._el_6,'\n    ',(null as any));
    this._text_31 = this.renderer.createText(this._el_2,'\n',(null as any));
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._text_10,
      this._el_11,
      this._text_12,
      this._el_13,
      this._text_14,
      this._text_15,
      this._text_16,
      this._el_17,
      this._text_18,
      this._el_19,
      this._text_20,
      this._text_21,
      this._el_22,
      this._text_23,
      this._text_24,
      this._el_25,
      this._text_26,
      this._text_27,
      this._el_28,
      this._text_29,
      this._text_30,
      this._text_31
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import16.HeaderComponent) && (0 === requestNodeIndex))) { return this._HeaderComponent_0_3.context; }
    if (((token === import44.RouterOutlet) && (13 === requestNodeIndex))) { return this._RouterOutlet_13_5.context; }
    if (((token === import21.LoadingWheelComponent) && (17 === requestNodeIndex))) { return this._LoadingWheelComponent_17_3.context; }
    if (((token === import23.InformationModalComponent) && (22 === requestNodeIndex))) { return this._InformationModalComponent_22_3.context; }
    if (((token === import25.ModalComponent) && (25 === requestNodeIndex))) { return this._ModalComponent_25_3.context; }
    if (((token === import27.ToastComponent) && (28 === requestNodeIndex))) { return this._ToastComponent_28_3.context; }
    if (((token === import45.NgClass) && ((6 <= requestNodeIndex) && (requestNodeIndex <= 30)))) { return this._NgClass_6_3.context; }
    if (((token === import45.NgClass) && ((2 <= requestNodeIndex) && (requestNodeIndex <= 31)))) { return this._NgClass_2_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._HeaderComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    const currVal_2_0_0:any = this._map_48((this.context.lookup.getBackColor() === 'LOGIN-BACK'),(this.context.lookup.getBackColor() === 'WHITESMOKE-BACK'));
    this._NgClass_2_3.check_ngClass(currVal_2_0_0,throwOnChange,false);
    this._NgClass_2_3.ngDoCheck(this,this._el_2,throwOnChange);
    const currVal_6_0_0:any = 'eva-3-container';
    this._NgClass_6_3.check_klass(currVal_6_0_0,throwOnChange,false);
    const currVal_6_0_1:any = this._map_49(this.context.isLoggedIn());
    this._NgClass_6_3.check_ngClass(currVal_6_0_1,throwOnChange,false);
    this._NgClass_6_3.ngDoCheck(this,this._el_6,throwOnChange);
    this._RouterOutlet_13_5.ngDoCheck(this,this._el_13,throwOnChange);
    this._LoadingWheelComponent_17_3.ngDoCheck(this,this._el_17,throwOnChange);
    this._InformationModalComponent_22_3.ngDoCheck(this,this._el_22,throwOnChange);
    this._ModalComponent_25_3.ngDoCheck(this,this._el_25,throwOnChange);
    this._ToastComponent_28_3.ngDoCheck(this,this._el_28,throwOnChange);
    this._vc_13.detectChangesInNestedViews(throwOnChange);
    const currVal_46:boolean = !this.context.lookup.isLoggedIn();
    if (import3.checkBinding(throwOnChange,this._expr_46,currVal_46)) {
      this.renderer.setElementProperty(this._el_0,'hidden',currVal_46);
      this._expr_46 = currVal_46;
    }
    const currVal_47:boolean = !this.context.endLoading;
    if (import3.checkBinding(throwOnChange,this._expr_47,currVal_47)) {
      this.renderer.setElementProperty(this._el_2,'hidden',currVal_47);
      this._expr_47 = currVal_47;
    }
    const currVal_50:boolean = !this.context.endLoading;
    if (import3.checkBinding(throwOnChange,this._expr_50,currVal_50)) {
      this.renderer.setElementProperty(this._el_19,'hidden',currVal_50);
      this._expr_50 = currVal_50;
    }
    this.compView_0.internalDetectChanges(throwOnChange);
    this.compView_17.internalDetectChanges(throwOnChange);
    this.compView_22.internalDetectChanges(throwOnChange);
    this.compView_25.internalDetectChanges(throwOnChange);
    this.compView_28.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this._vc_13.destroyNestedViews();
    this.compView_0.destroy();
    this.compView_17.destroy();
    this.compView_22.destroy();
    this.compView_25.destroy();
    this.compView_28.destroy();
    this._HeaderComponent_0_3.ngOnDestroy();
    this._RouterOutlet_13_5.ngOnDestroy();
    this._LoadingWheelComponent_17_3.ngOnDestroy();
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/root.component.ngfactory.ts